module.exports = __webpack_public_path__ + "media/newstyle/images/book-2-27b37fa58a35effba56bb13e75b8351d.png";